import classNames from 'classnames';
import { RefObject, forwardRef } from 'react';
import { ChangeHandler } from 'react-hook-form';

interface Props {
  id: string;
  label: string;
  name: string;
  onChange?: ChangeHandler;
  onBlur?: ChangeHandler;
  error?: string;
  defaultValue?: string;
}

/** @deprecated - I will be replaced in cluey-components v2 */
const FormField = forwardRef(
  ({ id, label, name, onChange, onBlur, error, defaultValue }: Props, ref: RefObject<HTMLInputElement>) => {
    return (
      <label className="flex w-full flex-col text-grey-5" htmlFor={id}>
        <span className="text-base font-medium text-grey-600">{label}</span>
        <input
          ref={ref}
          className={classNames(
            'mt-1 h-12 rounded-full border border-grey-200 px-2 py-2 focus:outline-none focus:ring focus:ring-blue-4/40',
            error ? 'border-red-5' : 'border-grey-3 focus:border-blue-4'
          )}
          type="text"
          name={name}
          id={id}
          onChange={onChange}
          onBlur={onBlur}
          defaultValue={defaultValue}
        />
        {error && <p className="mt-1 text-xs text-red-5">{error}</p>}
      </label>
    );
  }
);

export { FormField };
